export default "__VITE_ASSET__BOpTmqO3__"